<script lang="ts">
  import Layout from "$app/Layouts/Plan.svelte"
  import { resumeOnboarding, cancelOnboarding } from "$app/utils"
  import BrandPurpose from "$app/Pages/Plans/OnePageView/BrandPurpose.svelte"
  import BlueSky from "$app/Pages/Plans/OnePageView/BlueSky.svelte"
  import Values from "$app/Pages/Plans/OnePageView/Values.svelte"
  import Swot from "$app/Pages/Plans/OnePageView/Swot.svelte"
  import GoalBoxes from "$app/Pages/Plans/OnePageView/GoalBoxes.svelte"
  import Onboarding from "$app/Pages/Plans/OnePageView/Onboarding.svelte"
  import Course from "$app/Pages/Plans/Onboarding/Course.svelte"
  import { buildUserList } from "$app/utils/user_methods"
  import { appStore } from "$app/store.svelte"

  type Props = {
    departments: DepartmentType[]
    users: UserType[]
    headings: any[]
    beginning_of_quarter: Date
    plan_year: number
    fiscal_year: number
    annual_vision: string
    quarterly_vision: string
    last_meeting_date: Date
    today: Date
    update_core: boolean
    update_goals: boolean
    view_goals: boolean
    course: CourseType
    course_progress: any
    stripe_publish_key: string
    stripe_product: string
    stripe_price: string
    statements: StatementType[]
  }

  let props: Props = $props()

  let {
    departments,
    users,
    headings,
    beginning_of_quarter,
    plan_year,
    fiscal_year,
    annual_vision,
    quarterly_vision,
    last_meeting_date,
    today,
    update_core,
    update_goals,
    view_goals,
    course,
    course_progress,
    stripe_publish_key,
    stripe_product,
    stripe_price,
    statements
  } = props

  const userList = buildUserList(users)

  today = new Date(`${today}T00:00:00`)
  last_meeting_date = new Date(`${last_meeting_date}T00:00:00`)

  appStore.departments = departments
  appStore.today = today
  appStore.users = userList
  appStore.beginning_of_quarter = beginning_of_quarter
  appStore.plan_year = plan_year
  appStore.update_core = update_core
  appStore.update_goals = update_goals
  appStore.fiscal_year = fiscal_year
  appStore.last_meeting_date = last_meeting_date
  appStore.statements = statements
  appStore.headings = headings
  appStore.course = course

  appStore.assignees = [
    ...departments.map((d) => {
      return { ...d, type: "Department" }
    }),
    ...userList.map((u) => {
      return { ...u, type: "User" }
    })
  ] as AssigneeType[]
</script>

<Layout {...props}>
  <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
    {#if update_core}
      <Onboarding
        onresume={() => resumeOnboarding(appStore.plan.id)}
        oncancel={() => cancelOnboarding(appStore.plan.id)}
      />
    {/if}
    <div class="w-full grid grid-cols-12 gap-4">
      <div class="col-span-12 md:col-span-3" id="brand-purpose">
        <BrandPurpose />
      </div>
      <div class="col-span-12 md:col-span-9" id="values">
        <Values />
      </div>
    </div>
    <div class="w-full grid grid-cols-12 gap-4 mt-4">
      <div class="col-span-12 md:col-span-3" id="blue-sky">
        <BlueSky />
      </div>
      <div class="col-span-12 md:col-span-9">
        <div class="w-full grid grid-cols-2 md:grid-cols-4 gap-4">
          <div id="swot-strengths">
            <Swot sectionType="Strength" />
          </div>

          <div id="swot-weaknesses">
            <Swot sectionType="Weakness" />
          </div>
          <div id="swot-opportunities">
            <Swot sectionType="Opportunity" />
          </div>
          <div id="swot-threats">
            <Swot sectionType="Threat" />
          </div>
        </div>
      </div>
    </div>
    {#if view_goals}
      {#key appStore.onboarding}
        <GoalBoxes editable={update_goals} {annual_vision} {quarterly_vision} />
      {/key}
    {/if}
  </div>

  <div id="welcome-video"></div>

  {#if appStore.onboarding && !appStore.onboarding.completed_onboarding}
    <Course {course_progress} {stripe_publish_key} {stripe_product} />
  {/if}
</Layout>
